import { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import logo_yourfairshare from "../../assets/logo_azilis.png";

import { Link } from "react-router-dom";
import OverviewSection from "./OverviewSection.js";

const AboutYFSPublic = () => {
  const [height, setHeight] = useState(0);
  const ref = useRef();
  useEffect(() => {
    if (!ref.current) return; // wait for the elementRef to be available
    const resizeObserver = new ResizeObserver(() => {
      // Do what you want to do when the size of the element changes
      setHeight(ref.current.clientHeight);
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up
  }, []);

  return (
    <div
      className="p-3 pe-5 d-flex justify-content-end"
      style={{ backgroundColor: "#F2F8F0" }}
      ref={ref}
    >
      <Link className="nav-link" to={"/"}></Link>
      <div
        className="w-100 d-flex justify-content-center flex-column"
        style={{ zIndex: "10000" }}
      >
        <OverviewSection />
      </div>
    </div>
  );
};

export default AboutYFSPublic;
